import React, { useEffect, useContext, useState } from "react";
import { useManualQuery, useMutation, ClientContext } from "graphql-hooks";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { TextField, Typography, Breadcrumbs, Link, makeStyles } from "@material-ui/core";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Box } from "@material-ui/core";
import homeImg from "../../assets/icons/home_bread_crump.png";
import folderImg from "../../assets/icons/folder_bread_crump.png";
import formNameImg from "../../assets/icons/form_name_bread_crump.png";
import Autocomplete from "@mui/material/Autocomplete";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import { TENANT_CLIENT_LIST_QUERY } from "../../graphQL/client_qry";
import { REFRESH_TOKEN_MUTATION, STAFF_CLIENTS_QUERY } from "../../graphQL/user_qry";

import { project_url } from "../../constants/Data";

const findAnd = require("find-and");

const useStyles = makeStyles(() => ({
  text: {
    color: "#0D47A1",
    textAlign: "left",
    fontSize: 16,
    "& .MuiInputBase-root": {
      fontSize: "16px !important",
    },
  },
  box: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    color: "#0D47A1",
    fontSize: 16,
  },
  selectText: {
    color: "#0D47A1",
    textAlign: "left",
    fontSize: 16,
  },
  selectMenu: {
    "& .MuiMenuItem-root": {
      fontSize: 16,
      color: "#0D47A1",
      paddingTop: 0,
    },
  },
  linkStyle:{
    height:35,
    display:"flex",
    paddingLeft:5,
    paddingRight:5,
    alignItems:"center",
    "&:hover": {
      backgroundColor: "#E2F2FF",
    },
  }
}));

const breadcrumbStyle = {
  display: "flex",
  flexDirection: "row",
  color: "#0D47A1",
  fontSize: 16,
};
const itemStyle = {
  width: "250px", // Set desired width
  overflow: "hidden", // Handle overflow
  textOverflow: "ellipsis", // Show ellipsis if text overflows
  whiteSpace: "nowrap", // Prevent line breaks
  color: "#0D47A1",
  fontSize: 16,
};

const Header = ({ breadcrumbs }) => {
  const classes = useStyles();
  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [lightBackgrndClr, setLightBackgrndClr] = useState(true);
  const [pathname] = useState(window.location.pathname);
  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);
  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
    }
  };
  let clientId = 0;
  if (localStorage.getItem("clientId")) clientId = localStorage.getItem("clientId");
  let clientName = "";
  if (localStorage.getItem("clientName")) clientName = localStorage.getItem("clientName");

  let tenantId = 0;
  if(localStorage.getItem("tenantId"))
    tenantId = localStorage.getItem("tenantId");

  let tenantName = "";
  if(localStorage.getItem("tenantName"))
    tenantName = localStorage.getItem("tenantName");

  let isTenantAdmin = false;  
  if(localStorage.getItem("isTenantAdmin"))
    isTenantAdmin = JSON.parse(localStorage.getItem("isTenantAdmin"));

  let tenantUserId = 0;  
  if(localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");


  const [clientOptions, setClientOptions] = useState([]);
  const [value, setValue] = useState(null);
  const [fetchTenantClientList] = useManualQuery(TENANT_CLIENT_LIST_QUERY, {
    fetchPolicy: "network-only",
  });

  const [fetchStaffClientList] = useManualQuery(STAFF_CLIENTS_QUERY, {
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    (async () => fillClientDropDown())();
  }, []);

  const fillClientDropDown = async () => {
    if (isTenantAdmin)
    {
        const {
        loading: loadingClient,
        error: errorClient,
        data: dataClient,
      } = await fetchTenantClientList();
      if (dataClient && dataClient.tenantClientList) {
        let clientList = [];
        dataClient.tenantClientList.forEach((client, index) => {
          clientList.push({ label: client.name, id: client.clientId });
          if (client.clientId == clientId) {
            setValue(client.name);
            localStorage.setItem("clientId", client.clientId);
            localStorage.setItem("clientName", client.name);
          }
        });
        
        setClientOptions(clientList);
      }
      if (errorClient) console.log(errorClient);
    }
    else
    {
        const {
          loading: loadingClient,
          error: errorClient,
          data: dataClient,
        } = await fetchStaffClientList({
          variables: {
            tenantUserId: parseInt(tenantUserId),        
          },
        });
        if (dataClient && dataClient.getStaffClients) {
          let clientList = [];
          dataClient.getStaffClients.forEach((client, index) => {
            clientList.push({ label: client.name, id: client.clientId });
            if (client.clientId == clientId) {
              setValue(client.name);
              localStorage.setItem("clientId", client.clientId);
              localStorage.setItem("clientName", client.name);
            }
          });
          setClientOptions(clientList);
        }
        if (errorClient) console.log(errorClient);
    }
    
  };

  const handleChangeValue = event => {
    setValue(event.target.value);
    let currOpt = findAnd.returnFound(clientOptions, {
      label: event.target.value,
    });
    if (currOpt === undefined) return;
    localStorage.setItem("clientId", currOpt.id);
    localStorage.setItem("clientName", currOpt.label);
    window.location.href = `${project_url}/teams/`;
  };

  const handleClick = event => {
    setLightBackgrndClr(false);
  };
  const handleBlur = event => {
    setLightBackgrndClr(true);
  };

  return (
    <div>
      <Breadcrumbs
        sx={breadcrumbStyle}
        className={classes.text}
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
      >
        <Box className={classes.box}>
          Tenant:&nbsp;
          <Link className={classes.linkStyle} to={ project_url + "/tenant/dashboard" } component={RouterLink}>
            <Typography variant="h4" className={classes.text}>
              {tenantName}
            </Typography>
          </Link>
        </Box>
        <Box className={classes.box}>
          <Typography className={classes.selectText}>Client:&nbsp;</Typography>
          {clientOptions.length > 0 ? (
            <FormControl>
              <Select
                value={value}
                label="Label"
                onChange={handleChangeValue}
                variant="standard"
                disableUnderline
                MenuProps={{ classes: { paper: classes.selectMenu } }}
                sx={{
                  color: "#0D47A1",
                  fontSize: 16,
                  background: lightBackgrndClr ? "#E6E6E6" : "#BCBCBC",
                  paddingRight: 1.5,
                  paddingLeft: 1.5,
                  borderRadius: "8px",
                  // width: "157px",
                  // height: "38px",
                  "& .MuiSelect-select": {
                    background: lightBackgrndClr ? "#E6E6E6" : "#BCBCBC",
                  },
                  "& .MuiSelect-root": {
                    background: lightBackgrndClr ? "#E6E6E6" : "#BCBCBC",
                  },
                }}
                onMouseOver={handleClick}
                onBlur={handleBlur}
                onMouseLeave={handleBlur}
              >
                {clientOptions.map(client => (
                  <MenuItem key={client.id} value={client.label}>
                    {client.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          ) : (
            <Typography variant="h4" className={classes.text}>
              None
            </Typography>
          )}
          
        </Box>
        {breadcrumbs && (
          <Box className={classes.box}>
            <Link className={classes.linkStyle} to={ project_url + "/teams"} component={RouterLink}>
              <Typography variant="h4" className={classes.text}>
                Teams List
              </Typography>
            </Link>
          </Box>
        )}
        {!breadcrumbs && (
          <Box className={classes.box}>
            <Typography variant="h4" className={classes.text}>
              Teams List
            </Typography>
          </Box>
        )}
        {breadcrumbs &&
          breadcrumbs.map((option, i) => (
            <Box className={classes.box}>
              {option.link && (
                <Link className={classes.linkStyle} to={option.link} component={RouterLink}>
                  <Typography variant="h4" className={classes.text}>
                    {option.label}
                  </Typography>
                </Link>
              )}
              {!option.link && (
                <Typography variant="h4" className={classes.text}>
                  {option.label}
                </Typography>
              )}
            </Box>
          ))}
      </Breadcrumbs>
    </div>
  );
};

export default Header;
